import { render } from "./ItemInfo.vue?vue&type=template&id=2af9f513"
import script from "./ItemInfo.vue?vue&type=script&lang=js"
export * from "./ItemInfo.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ItemInfo.vue?vue&type=style&index=0&id=2af9f513&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__